import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useApi from '../api/base/useApi';

import { chatActions } from '../../lib/redux/chat/slice';

export default function useGuidedSuggestedPrompts() {
  const auth = useSelector((state) => state.auth?.data);
  const { sessionId, tabbedSessions } = useSelector((state) => state.chat);
  const { mode, advanceActiveTab } = useSelector((state) => state.embed);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const api = useApi();
  // const mentor = useSelector((state) => state.mentors.mentor);
  // const enableGuidedPrompts = mentor?.enable_suggested_prompts;

  const loadGuidedPrompts = async () => {
    if (loading) {
      return;
    }

    const url = `/api/ai-prompt/orgs/${auth?.tenant?.key}/users/${auth?.user?.user_nicename || 'anonymous'}/sessions/${
      mode === 'advanced' ? tabbedSessions[advanceActiveTab] : sessionId
    }/guided-prompts/`;
    setLoading(true);
    const response = await api.get(url);
    setLoading(false);
    if (response?.data) {
      const prompts = response.data?.ai_prompts;
      if (prompts?.length > 0) {
        setGuidedPrompts(prompts);
      } else {
        const retry = await api.get(url);
        if (retry?.data?.ai_prompts?.length > 0) {
          setGuidedPrompts(retry.data.ai_prompts);
        }
      }
    }
  };

  const setGuidedPrompts = (prompts) => {
    dispatch(chatActions.guidedPromptsUpdated(prompts));
  };

  const handleReloadGuidedQuestionsBtnClick = () => {
    loadGuidedPrompts();
  };

  return { handleReloadGuidedQuestionsBtnClick, loadGuidedPrompts, loading };
}
